import TwoFActionTypes from './2FA-types'

const INITIAL_STATE = {
    twoFaStatus: { failed: false, success: false, wrongCode: false, resetCode: false },
    success: null,
    loading: null,
    twoFaType: null,
    authenticationTypes: null,
    authenticationSetup: null,
}

const alertReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TwoFActionTypes.SET_2FA_TYPE:
            return {
                ...state,
                twoFaType: action.payload,
            }
        case TwoFActionTypes.STATUS_CHANGE_OF_2FA:
            return {
                ...state,
                twoFaStatus: action.payload,
            }

        case TwoFActionTypes.START_GOOGLE_AUTHENTICATION_SETUP:
            return {
                ...state,
                loading: true,
            }
        case TwoFActionTypes.SUCCESS_GOOGLE_AUTHENTICATION_SETUP:
            return {
                ...state,
                authenticationSetup: action.payload,
                loading: null,
                success: { ...state.success, GOOGLE_AUTHENTICATION_SETUP: true },
            }
        case TwoFActionTypes.FINISH_GOOGLE_AUTHENTICATION_SETUP:
            return {
                ...state,
                authenticationSetup: null,
                loading: null,
                success: { ...state.success, GOOGLE_AUTHENTICATION_SETUP: null },
            }
        case TwoFActionTypes.FAILURE_GOOGLE_AUTHENTICATION_SETUP:
            return {
                ...state,
                authenticationSetup: null,
                loading: null,
                success: { ...state.success, GOOGLE_AUTHENTICATION_SETUP: null },
            }

        case TwoFActionTypes.START_CHANGE_2FA_AUTHENTICATION_TYPE:
        case TwoFActionTypes.VERIFY_GOOGLE_AUTH_CODE:
            return {
                ...state,
                loading: true,
            }
        case TwoFActionTypes.SUCCESS_CHANGE_2FA_AUTHENTICATION_TYPE:
            return {
                ...state,
                loading: null,
                success: { ...state.success, CHANGE_2FA_AUTHENTICATION_TYPE: true },
            }
        case TwoFActionTypes.FINISH_CHANGE_2FA_AUTHENTICATION_TYPE:
            return {
                ...state,
                loading: null,
                success: { ...state.success, CHANGE_2FA_AUTHENTICATION_TYPE: null },
            }
        case TwoFActionTypes.FAILURE_CHANGE_2FA_AUTHENTICATION_TYPE:
            return {
                ...state,
                loading: null,
                success: { ...state.success, CHANGE_2FA_AUTHENTICATION_TYPE: null },
            }
        case TwoFActionTypes.START_FETCH_AUTHENTICATION_TYPES:
            return {
                ...state,
                loading: true,
            }
        case TwoFActionTypes.SUCCESS_FETCH_AUTHENTICATION_TYPES:
            return {
                ...state,
                authenticationTypes: action.payload,
                loading: null,
            }
        case TwoFActionTypes.FINISH_FETCH_AUTHENTICATION_TYPES:
            return {
                ...state,
                authenticationTypes: null,
                loading: null,
            }
        case TwoFActionTypes.FAILURE_FETCH_AUTHENTICATION_TYPES:
            return {
                ...state,
                authenticationTypes: null,
                loading: null,
            }
        default:
            return state
    }
}

export default alertReducer
